import React, { useContext, useEffect } from 'react'
import start from '../../Assets/Images/start.png'
import play from '../../Assets/Images/play.png'
import pause from '../../Assets/Images/pause.png'
import end from '../../Assets/Images/end.png'
import Volume from './Volume'
import { SongContext } from '../../Routes/Routes1'
import axios from 'axios'

export default function Control({isPlaying,setPlaying,audio}) {
    const {songs,setSong}=useContext(SongContext)
    const {songGroup,setSongGroup}=useContext(SongContext)

    const PORT=process.env.REACT_APP_URL_PORT

    useEffect(()=>{
        axios.get(`https://${PORT}/admin/music_data`)
        .then(res=>{
            setSongGroup(res.data[songs.sType+"s"])
        })
    },[songs,PORT,setSongGroup])
    function nextSong(){
        if(parseInt(songs._id[4]) < songGroup.length){
            setSong(songGroup[parseInt(songs._id[4])])
        }
        else{
            setSong(songGroup[0])
        }
        
    }

    function startAgain(){
        audio.current.currentTime=0
        
    }

    return (
        <center>
            <button id="start">
                <img src={start} alt="start" onClick={startAgain} />
            </button>
            <button id="play" onClick={()=>setPlaying(!isPlaying)}>
                <img src={isPlaying? pause:play} alt="play" />
            </button>
            <button id="end" onClick={nextSong}>
                <img src={end} alt="end" />
            </button>
            <Volume audio={audio}/>
        </center>
    )
}
